module.exports = __webpack_public_path__ + "img/css-framework2.47ed929d.png";